function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_733",
  "data-name": "Rectangle 733",
  width: 30.273,
  height: 14.34,
  fill: "#0078d7"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1445",
  "data-name": "Group 1445",
  transform: "translate(30.273 14.34) rotate(180)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1444",
  "data-name": "Group 1444",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1443",
  "data-name": "Group 1443",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_669",
  "data-name": "Path 669",
  d: "M29.832,6.474h0L23.671.343a1.179,1.179,0,0,0-1.663,1.671L26.144,6.13H1.179a1.179,1.179,0,0,0,0,2.358H26.144L22.008,12.6a1.179,1.179,0,0,0,1.663,1.671l6.159-6.13h0a1.18,1.18,0,0,0,0-1.669Zm0,0",
  transform: "translate(0 0)",
  fill: "#0078d7"
}))));

function SvgGoBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.273,
    height: 14.34,
    viewBox: "0 0 30.273 14.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBackArrow);
export default __webpack_public_path__ + "static/media/go-back-arrow.0048cd81.svg";
export { ForwardRef as ReactComponent };